import React from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import _ from 'lodash';

import * as hcProfileActions from './actions';
import * as workFlowActions from './tabs/workflow/actions';
import * as registerActions from '../register/actions';
import * as commonActions from '../common/actions';
import * as loginActions from '../auth/login/actions';
import AddHCModal from '../hiringclients/addHCModal';

import ProfileFrame from '../common/profile';
import Tabs from './tabs';
import Utils from '../../lib/utils';

import './hcprofile.css';

class HCProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false
    }
    const { hcId } = props.match.params;
    props.actions.fetchHCProfile(hcId);
    this.props.workFlowActions.setHcId(hcId);
    this.props.commonActions.setLastHiringClient(hcId);
    this.props.registerActions.fetchResources();
    //  this.props.actions.fetchScListForSelectComponent(hcId);
    localStorage.setItem('currentSystem', 'pq');
    this.props.loginActions.setCurrentSystem('pq');
    this.onEditProfile = this.onEditProfile.bind(this);
    this.onCloseEditProfile = this.onCloseEditProfile.bind(this);

    this.restrictedPQRoles = [25, 26]; // Super Hiring Client Full Access
  }

  componentWillUnmount() {
    this.props.commonActions.setHeaderTitle('');
  }

  onCloseEditProfile(update) {
    if(update){
      const { hcId } = this.props.match.params;
      this.props.actions.fetchHCProfile(hcId);
    }

    this.setState({showModal: false});
  }

  onEditProfile() {
    this.setState({showModal: true});
  }

  render() {
    //CF-1035: Role pq 25 & 26 is intended to see only the HC profile associated with the account
    if(this.restrictedPQRoles.find(hc => hc === Number(this.props.userProfile.RoleID)) && !this.props.userProfile.multipleHiringClients.find(hc => hc === Number(this.props.match.params.hcId))) {
      return <Redirect push to="/hiringclients" />
    }
    const {
      name,
      registrationUrl,
      address1,
      address2,
      city,
      state,
      phone,
      zipCode,
      logo,
      AllowApplications
    } = this.props.hcprofile.profileData;
    const baseURL  = process.env.REACT_APP_FRONTEND_URL
    const domain = baseURL.replace(/^https?\:\/\//i, "");
    const sidebarInfo = {
      header: {
        logo: logo ? `data:image/jpeg;base64,${logo}` : 'http://via.placeholder.com/350x170'
      },
      sections: [
        {
          sectionTitle: name,
          subsections: [
            {
              label: 'Address 1',
              value: address1
            },
            {
              label: 'Url',
              value: domain + "/apply/" +  registrationUrl
            },
            {
              label: 'Address 2',
              value: address2
            },
            {
              label: 'Phone Number',
              value: phone && Utils.formatPhoneNumber(phone)
            },
            {
              label: 'City',
              value: city && state && `${city}, ${state}`,
            },
            {
              label: 'Postal Code',
              value: zipCode
            }
          ]
        }
      ]
    };

    if (this.props.hcprofile.errorHCProfile) {
      return this.props.hcprofile.errorHCProfile;
    } else if (_.isEmpty(this.props.hcprofile.profileData)) {
      return (
        <div style={{ width:'100%', height:'200px', display: 'flex',
          alignItems: 'center', justifyContent: 'center' }}>
          <div className="spinner-wrapper">
            <div className="spinner" />
          </div>
        </div>
      );
    }

    return (
      <ProfileFrame
        permissions={{
          edit: {
            masterTab: 'hiring_clients',
            sectionTab: 'edit_hiring_client'
          }
        }}
        frameTitle={'Hiring Clients'}
        sidebar={sidebarInfo}
        onEditProfile={this.onEditProfile}
      >
        <Tabs {...this.props} />
        <Modal
          show={this.state.showModal}
          onHide={this.onCloseEditProfile}
          className="add-item-modal add-hc">
          <Modal.Body className="add-item-modal-body">
            <AddHCModal 
              onClose={this.onCloseEditProfile} 
              profile={this.props.hcprofile.profileData}
            />
          </Modal.Body>
        </Modal>
      </ProfileFrame>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    hcprofile: state.HCProfile,
    userProfile: state.login.profile
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(hcProfileActions, dispatch),
    workFlowActions: bindActionCreators(workFlowActions, dispatch),
    registerActions: bindActionCreators(registerActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    loginActions: bindActionCreators(loginActions, dispatch),
  }
};


export default connect(mapStateToProps, mapDispatchToProps)(HCProfile);
